import React from "react";
import Error from "components/form/Error";
import InputArea from "components/form/InputArea";

const DynamicPaymentGateway = ({
  dataInput,
  setDataInput,
  register,
  errors,
}) => {
  const handleChange = (e, index) => {
    const updated = [...dataInput];
    updated[index].charge = Number(e.target.value);
    setDataInput(updated);
  };

  return (
    <div className="space-y-4">
      {dataInput.map((item, index) => (
        <div key={index} className="grid grid-cols-2 gap-4 items-center">
          <InputArea
            register={register}
            name={`payment_type_${index}`}
            label="Payment Type"
            type="text"
            value={item.payment_type}
            readOnly
            required={false}
          />

          <div>
            <InputArea
              register={register}
              name={`charge_${index}`}
              label="Charge"
              type="text"
              min="0"
              defaultValue={item.charge}
              onChange={(e) => handleChange(e, index)}
              placeholder="Charge"
            />
            <Error errorName={errors[`charge_${index}`]} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default DynamicPaymentGateway;
